import React from "react";

const Logo = () => {
  return (
    <div className="mx-auto mb-4 flex w-fit  items-center gap-2 rounded-md bg-white py-2 px-2">
      <img
        src="https://assets.learntube.ai/files/post-payment-updates/image%2011.svg?updatedAt=1728356261811"
        loading="eager"
        alt=""
        className="h-[1.75rem] w-[1.75rem]"
      />
      <p className="text-md font-medium text-black">LearnTube.ai</p>
    </div>
  );
};

export default Logo;
